export default __webpack_public_path__ + "static/media/2688.0adf4478.png";